import DashboardOIGSAMItem from "./DashboardOIGSAMItem";

export default DashboardOIGSAMItem;
